import { FC } from "react";
import FormGroupLabel from "components/common/text/FormGroupLabel";
import { NumberStepper, segmentButtonClass } from "../NumberStepper";

export type ScheduleLimitMode = "hours" | "days";

export interface ScheduleLimitFieldProps {
  mode: ScheduleLimitMode;
  onModeChange: (mode: ScheduleLimitMode) => void;
  hours: number;
  onHoursChange: (value: number) => void;
  maxDays: number;
  onMaxDaysChange: (value: number) => void;
  hoursError?: string;
  maxDaysError?: string;
}

export const ScheduleLimitField: FC<ScheduleLimitFieldProps> = ({
  mode,
  onModeChange,
  hours,
  onHoursChange,
  maxDays,
  onMaxDaysChange,
  hoursError,
  maxDaysError,
}) => {
  const activeError = mode === "hours" ? hoursError : maxDaysError;

  return (
    <div className="flex flex-col gap-2">
      <FormGroupLabel marginBottom>Schedule limit</FormGroupLabel>
      <div className="flex rounded-lg border border-border bg-card p-1">
        <button
          type="button"
          aria-pressed={mode === "hours"}
          className={segmentButtonClass(mode === "hours")}
          onClick={() => onModeChange("hours")}
        >
          Hours per day
        </button>
        <button
          type="button"
          aria-pressed={mode === "days"}
          className={segmentButtonClass(mode === "days")}
          onClick={() => onModeChange("days")}
        >
          Total days
        </button>
      </div>
      <div className="flex justify-center rounded-lg border border-border bg-muted/40 px-4 py-2">
        {mode === "hours" ? (
          <NumberStepper
            value={hours}
            onChange={onHoursChange}
            min={1}
            max={24}
            unit="hrs"
            ariaLabel="max hours per day"
            compact
          />
        ) : (
          <NumberStepper
            value={maxDays}
            onChange={onMaxDaysChange}
            min={5}
            max={366}
            unit="days"
            ariaLabel="max total days"
            compact
          />
        )}
      </div>
      {activeError ? (
        <FormGroupLabel className="mt-0" noUpperCase warningLabel>
          {activeError}
        </FormGroupLabel>
      ) : null}
    </div>
  );
};
